import { useEffect } from 'react';
import ReactDom from 'react-dom';

export default function OverlayContainer(props) {
    const container = document.getElementById(props.container || 'xs-overlay-container');
    let overlayContainer = null;


    useEffect(() => {
        document.body.classList.add('no-scroll');
        return () => {
            document.body.classList.remove('no-scroll');
            if (overlayContainer != null) {
                overlayContainer.remove();
            }
        };
    }, []);

    useEffect(() => {
        if (!document.body.classList.contains("cg_device_ios")) return
        const scrollTop = document.documentElement.scrollTop;
        document.body.style.position = "fixed";
        return () => {
            document.body.style.position = "";
            document.documentElement.scrollTop = scrollTop
        }
    }, [])

    if (container == null) {
        return null;
    } else if (props.isBetslip) {
        container.classList?.add('xs-overlay-container-betslip');
    }

    overlayContainer = container.querySelector(`#${props.id}`);
    if (overlayContainer == null) {
        overlayContainer = document.createElement('div');
        overlayContainer.id = props.id;
        overlayContainer.classList.add('c_3');
        container.append(overlayContainer);
    }

    return ReactDom.createPortal(props.children, overlayContainer);
}
